import { location } from './Hooks';

const transformPath = (path, exact) => {
	const transformed = path
		.replace(/\?:([a-z_]{1,30})/g, '?(.*?)')
		.replace(/:([a-z_]{1,30})/g, '(.+?)')
		.replace(/\//g, '\\/');
	return new RegExp(`^${transformed}${exact ? '$' : ''}`);
};

const extractParamKeys = (path) => {
	const params = path.match(/:([a-z_]{1,30})/g);
	return params ? params.map((param) => param.substr(1)) : [];
};

// it is use in SubRouter
export const matchedPath = (path, url, exact, nested) => {
	url = cleanUrl(url);
	const final_url = nested ? currentUrl(path, url) : url;
	const model = transformPath(path, exact);
	const isMatched = final_url.match(model);
	return {
		isMatched: !!isMatched,
		paramvalues: isMatched ? isMatched.slice(1) : [],
	};
};

// it is use in Route
export const extractParams = (path, url, exact, nested) => {
	const { isMatched, paramvalues } = matchedPath(path, url, exact, nested);
	const paramkeys = extractParamKeys(path);
	const parameters = paramkeys.reduce((result, current_key, index) => {
		result[current_key] = paramvalues[index] || undefined;
		return result;
	}, {});

	return {
		isMatched,
		parameters,
	};
};

// it is use in Route
export const currentUrl = (path, url) => {
	const model = transformPath(`(${path})/.*`);
	return path === '/' ? '/' : url.replace(model, (a, current) => current);
};

const cleanUrl = (url) => url.split(/\?|#/)[0]; //remove hash from current url

//it is use in Route and SubRouter
export const requestIdleCallback =
	((cb) => setTimeout(cb, 0));

export const cancelIdleCallback =
	((id) => clearTimeout(id));

//it is use in Router when mounted
export const currentPath = (legacy) => {
	const { pathname, search, hash } = location;
	const routerurl = new URLSearchParams(search).get("url")
	return legacy 
		? ( hash ? `/${hash}` : '/#/' ) 
		: (routerurl 
			? routerurl + hash 
			: pathname + search + hash
		);
};
